import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import Namsteji_Manikchand_Icon from '../../../../../assets/images/Namsteji_Manikchand_Icon.svg';
import { Link } from 'react-router-dom';
import config from '../../../../../config/environment';

const statusColor: Record<string, string> = {
  '0': 'bg-yellow-100 text-yellow-700 border border-yellow-300',
  '1': 'bg-indigo-100 text-indigo-700 border border-indigo-300',
  '2': 'bg-orange-100 text-orange-700 border border-orange-300',
  '3': 'bg-purple-100 text-purple-700 border border-purple-300',
  '4': 'bg-green-100 text-green-700 border border-green-300',
  '5': 'bg-amber-100 text-amber-700 border border-amber-300',
  '6': 'bg-red-100 text-red-700 border border-red-300',
  '7': 'bg-red-100 text-red-700 border border-red-300',
};

const OrderHistoryPageMobile: React.FC<any> = ({
  displayedOrders,
  currentPage,
  setCurrentPage,
  totalPages,
  recordsPerPage,
}) => {
  const SERVER_URL = config.SERVER_URL;
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const scrollFired = useRef(false);
  const [allOrders, setAllOrders] = useState<any[]>([]);

  /**  Detect scroll inside div */
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;

    const handleScroll = () => {
      if (!scrollContainer) return;

      const { scrollTop, scrollHeight, clientHeight } = scrollContainer;

      /** Check if scrolled to bottom */
      // if (scrollTop + clientHeight >= scrollHeight - 10 && !scrollFired.current) {
      if (scrollTop + clientHeight >= scrollHeight - recordsPerPage && !scrollFired.current) {
        if (currentPage < totalPages) {
          scrollFired.current = true;
          setCurrentPage((prev: number) => prev + 1);
        }
      }
    };

    scrollContainer?.addEventListener('scroll', handleScroll);
    return () => scrollContainer?.removeEventListener('scroll', handleScroll);
  }, [currentPage, totalPages, setCurrentPage]);

  /** Reset scroll trigger and update allOrders */
  useEffect(() => {
    scrollFired.current = false;
    setAllOrders(prevOrders => {
      const prevOrderIds = new Set(prevOrders.map(o => o.name));
      const newOrders = displayedOrders.filter((o: any) => !prevOrderIds.has(o.name));
      return [...prevOrders, ...newOrders];
    });
  }, [displayedOrders]);

  return (
    <>
      <div className='overflow-scroll max-h-[44rem]' ref={scrollContainerRef}>
        {allOrders.length > 0 ? (
          allOrders.map((order: any) => {
            const currentStatus = order.status_timeline?.find((s: any) => s.code === order.current_status_code);

            const statusText = currentStatus?.status || '---';
            const colorClass =
              statusColor[order.current_status_code] || 'bg-gray-100 text-gray-700 border border-gray-300';
            const qty = order.items.reduce((sum: any, item: any) => sum + item.qty, 0);
            const QTY = qty > 1 ? `+${qty - 1}` : null;

            return (
              <>
                <Link to={`/orders/details/${order.name}`}>
                  <div className='px-3' key={order.name}>
                    <div className='bg-white rounded-xl shadow-lg  mb-4 font-poppins'>
                      <div className='flex justify-between items-start mb-3 px-2 py-4 rounded-t-xl bg-[#F5F5F5]'>
                        <div>
                          <p className='font-semibold text-[#00000099] text-sm sm:text-base font-poppins'>
                            {order.name}
                          </p>
                          <p className='text-[#9E9E9E] text-xs sm:text-sm font-poppins'>
                            {order.status_timeline[0]?.timestamp
                              ? moment(order.status_timeline[0].timestamp).format('DD/MM/YYYY')
                              : '---'}
                          </p>
                        </div>

                        <span className={`px-1.5 py-1 rounded-full text-[11px] font-medium ${colorClass}`}>
                          {statusText}
                        </span>
                      </div>

                      <div className='flex justify-between items-center px-4 pb-4'>
                        <div className='flex items-center gap-2'>
                          {order.items.slice(0, 3).map((item: any, idx: number) => (
                            <img
                              key={idx + 'a'}
                              src={
                                item?.website_image ? `${SERVER_URL}${item.website_image}` : Namsteji_Manikchand_Icon
                              }
                              alt='Image'
                              className='w-12 h-12 sm:w-14 sm:h-14 rounded-md object-cover border border-gray-200 bg-[#F5F5F5]'
                            />
                          ))}

                          {QTY && (
                            <div className='w-12 h-12 sm:w-14 sm:h-14 rounded-md flex items-center justify-center text-gray-600 font-medium bg-[#F5F5F5]'>
                              {QTY}
                            </div>
                          )}
                        </div>

                        <p className='text-gray-800 font-medium text-base sm:text-lg font-poppins'>
                          ₹{order.grand_total.toFixed(2)}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
              </>
            );
          })
        ) : (
          <div className='text-center text-gray-500 py-4'>No orders found.</div>
        )}
      </div>
    </>
  );
};

export default OrderHistoryPageMobile;
